import React, { useEffect, useRef } from 'react';

import { Layout } from 'antd';

import MenuDt from './Main/components/MenuDt';
import WorkDirectionRoutes from './TimeTrackerRoutes';
import styles from './styles.module.less';
import { signOutDt } from './contexts/AuthProvider';
import classNames from 'classnames';
import { useIsMobile } from 'packages/utils';
import CircleButton from 'components/Buttons/CircleButton';
import { useParams, useLocation } from 'react-router-dom';
import { useTimeTracker } from './contexts/TimeTrackerProvider';

const { Content, Header, Sider } = Layout;
const TimeTracker = () => {
  const { orgId } = useParams();
  const { setCorporationId, collapsed, setCollapsed } = useTimeTracker();
  const { isMobile } = useIsMobile();
  const isHovering = useRef(false);
  const originalCollapsedState = useRef(collapsed);
  const location = useLocation();
  const isReportView = !!location.search;

  useEffect(() => {
    if (orgId) {
      setCorporationId(orgId);
    }
  }, [orgId]);

  // Sync ref with state when it changes externally (button toggle)
  useEffect(() => {
    if (!isHovering.current) {
      originalCollapsedState.current = collapsed;
    }
  }, [collapsed]);

  useEffect(() => {
    if (!isReportView) {
      setCollapsed(false);
    }
  }, [isReportView]);

  return (
    <Layout className={classNames('gx-app-layout', styles.mainLayoutDt)}>
      <Sider 
        className={styles.siderMenu} 
        trigger={null} 
        collapsed={collapsed}
      >
        <MenuDt  signOutDt={signOutDt} collapsed={collapsed} setCollapsed={setCollapsed} />
      </Sider>
      <Layout>
        {isMobile && (
          <Header className="site-layout-background">
            <CircleButton
              iconName="menu"
              onClick={() => setCollapsed(prev => !prev)}
              type="secondary"
            />
          </Header>
        )}
        <Content className={classNames('site-layout-background', styles.mainContentDt)}>
          <WorkDirectionRoutes />
        </Content>
      </Layout>
    </Layout>
  );
};

export default React.memo(TimeTracker);
